import { render, staticRenderFns } from "./Fabrics.vue?vue&type=template&id=c7154800&scoped=true&"
import script from "./Fabrics.vue?vue&type=script&lang=js&"
export * from "./Fabrics.vue?vue&type=script&lang=js&"
import style0 from "./Fabrics.vue?vue&type=style&index=0&id=c7154800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7154800",
  null
  
)

export default component.exports